/* tslint:disable */
export enum Function {
    Driver = 0,
    Passenger = 1,
    NotDefined = 2
}